export default __webpack_public_path__ + "static/media/logo_ea.5d8ea340.png";